import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { Routes, RoutesContext } from 'routing/routes'
import { Home } from './Home/Home'
import { HomeStore } from './Home/HomeStore'
import './App.scss'

interface Props {
  routes: Routes
}


function chooseRoute(routes: Routes) {
  switch (routes.currentView) {
    case 'home':
      return <Home store={new HomeStore()} />
    default:
      routes.setCurrentView('home')
      return <></>
  }
}

export const App: FC<Props> = observer(function App({ routes }) {
  return <RoutesContext.Provider value={routes}>{chooseRoute(routes)}</RoutesContext.Provider>
})
